import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, walls, ball, rng } from "./helpers";

export const pour: Demo = {
	id: "pour",
	title: "Circle pour (stress)",
	blurb:
		"Hundreds of circles stream into a bin and then fall asleep once settled — a live look at throughput and the sleeping system keeping idle bodies cheap.",
	category: "Stacking & Stress",
	build(): Scene {
		const world = makeWorld();
		floor(world, 16);
		walls(world, 6, 18);

		const random = rng(7);
		const max = 320;
		let spawned = 0;
		let acc = 0;
		const interval = 0.03; // seconds between drops

		const onBeforeStep = (dt: number): void => {
			if (spawned >= max) return;
			acc += dt;
			while (acc >= interval && spawned < max) {
				acc -= interval;
				const x = (random() - 0.5) * 8;
				ball(world, x, -8, 0.3, {
					restitution: 0.05,
					friction: 0.5,
					velocity: [(random() - 0.5) * 2, 2],
				});
				spawned++;
			}
		};

		return { world, camera: new Camera(0, -3, 26), onBeforeStep };
	},
};
